import React from 'react';
import { withRouter } from 'react-router-dom';
import { HASH_HOME_HEADER } from 'routes/routes';
import { makeStyles } from '@material-ui/styles';
import LogoBase from './LogoBase';

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  logo: {
    cursor: 'pointer',
    display: 'flex',
    height: 56,
    marginBottom: -3,
    marginRight: spacing(4),
    [breakpoints.down('xs')]: {
      height: 40
    }
  }
}));
const LogoAppBar = ({ history }) => {
  const classes = useStyles({})
;
  return <LogoBase className={classes.logo} onClick={() => history.push(HASH_HOME_HEADER)} />;
};

export default withRouter(LogoAppBar);
